import React, { useEffect, useState } from 'react';
import { EuiBadge, EuiFlexItem, EuiListGroup } from '@elastic/eui';
import { ConfirmRemove } from './confirmRemove';
import { ItemAdjuntoList } from '../../../ui/src/routes/Partes/Formulario/itemAdjunto';
import './styles.css';

export const ListadoConDescarga = (props) =>{

  let {options, handleDownload, handleRemove, onChangeTypeAdjunto, onlyConfirm}=props;
  let [listOptions, setListOptions] = useState(options)
  let [itemRemove, setItemRemove] = useState(undefined)
  let [openConfirm, setOpenConfirm] = useState(false)
  
  useEffect(()=>{
    props.getNumberAdjuntos && props.getNumberAdjuntos(listOptions.length)
  },[listOptions])


  const onDownLoad = (id, nombre) =>{
    return handleDownload ? handleDownload(id, nombre) : ()=>{}
  }

  const onConfirm = async(response) =>{
    setOpenConfirm(false)
    if(response!==undefined){
      let resp = await (handleRemove && handleRemove(itemRemove,response))
      if(resp){
        let pos = listOptions.findIndex((o) => o.id === itemRemove);
        let newData = [ ...listOptions ];
        newData.splice(pos, 1);
        setListOptions([...newData])
      }
    }
  }

  const onRemove = (id) =>{
    setItemRemove(id)
    setOpenConfirm(true)
  }

  const getExtraAction = (id) => {
    return handleRemove ?
      {
        color: 'danger',
        onClick: ()=>onRemove(id),
        iconType: 'crossInACircleFilled',
        iconSize: 's',
        alwaysShow: true,
        className:'btnRemoveListAdj'
      }
    : null
  }

  const renderOptions = () =>{

    return listOptions.map((o)=>{
      return (<ItemAdjuntoList item={o} extraAction={getExtraAction} changeType={onChangeTypeAdjunto} onDonwLoad={onDownLoad}/>)
    })
  }

if(listOptions)
{
  return listOptions.length>0 ? 
    <>
    <EuiListGroup style={props.style && props.style}>
      {renderOptions()}
    </EuiListGroup>
    <ConfirmRemove open={openConfirm} onConfirm={onConfirm} onlyConfirm={true}/>
    </>
  :
  <EuiFlexItem grow={false} key="danger">
  <EuiBadge color="danger">Sin datos</EuiBadge>
  </EuiFlexItem> 
}else{return null}

}